export default {
  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',

  'menu.catalog': '商品管理',
  'menu.catalog.products': '商品列表',
  'menu.catalog.categories': '分类管理',
  'menu.catalog.inventory': '库存管理',
  'menu.catalog.media': '媒体库',

  'menu.orders': '订单询盘',
  'menu.orders.orders': '订单列表',
  'menu.orders.inquiries': '询盘管理',
  'menu.orders.quotations': '报价管理',
  'menu.orders.abandoned': '弃单管理',

  'menu.customers': '客户管理',
  'menu.customers.list': '客户列表',
  'menu.customers.groups': '客户分组',

  'menu.content': '内容管理',
  'menu.content.pages': '页面管理',
  'menu.content.blog': '博客新闻',
  'menu.content.navigation': '菜单导航',
  'menu.content.banners': '横幅广告',

  'menu.marketing': '营销推广',
  'menu.marketing.discounts': '优惠券',
  'menu.marketing.email': '邮件营销',
  'menu.marketing.seo': 'SEO设置',
  'menu.marketing.analytics': '数据分析',

  'menu.settings': '系统设置',
  'menu.settings.store': '公司信息',
  'menu.settings.domains': '域名管理',
  'menu.settings.languages': '多语言',
  'menu.settings.currencies': '货币设置',
  'menu.settings.shipping': '物流设置',
  'menu.settings.taxes': '税费设置',
  'menu.settings.payments': '支付设置',
  'menu.settings.notifications': '通知设置',

  'menu.system': '系统管理',
  'menu.system.users': '员工权限',
  'menu.system.audit': '操作日志',
  'menu.system.integrations': '集成应用',

  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.logout': '退出登录',
};
